import { Modal, Select, Space, Typography } from "antd";
import { getAllAccountsList } from "api/services/AccountService";
import { AccountStatus, TAccountPicklist } from "api/services/models/types";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import { useEffect, useState } from "react";

const OptionRenderer = (account: TAccountPicklist) => {
  return (
    <span style={{ color: account.accountStatus === AccountStatus.Inactive ? "gray" : "black" }}>
      {account.accountId}
    </span>
  );
};

const AccountPicker = () => {
  const { webDUser, updateAccountId, accountId } = useTDAuthentication();
  const [accounts, setAccounts] = useState<TAccountPicklist[]>();

  useEffect(() => {
    if (webDUser && "TD" === webDUser.user.accountId) {
      getAllAccountsList()
        .then(accounts => setAccounts(accounts))
        .catch(console.error);
    }
  }, [webDUser]);

  const onAccountChange = (value: string) => {
    Modal.destroyAll();
    if (value) {
      updateAccountId?.(value);
    }
  };

  if (!webDUser || "TD" !== webDUser.user.accountId) {
    return <></>;
  }

  return (
    <Space direction={"horizontal"} className="account-picker">
      <Typography.Text style={{ fontSize: ".85rem", fontWeight: "500" }}>Select Account:</Typography.Text>
      <Select
        defaultValue={accountId}
        showSearch
        variant="borderless"
        className="drop-down-menu"
        options={accounts}
        optionFilterProp="accountId"
        fieldNames={{ label: "accountId", value: "accountId" }}
        style={{
          width: "200px",
          maxWidth: "100%"
        }}
        loading={!accounts}
        onChange={onAccountChange}
        optionRender={item => OptionRenderer(item.data)}
      />
    </Space>
  );
};

export default AccountPicker;
